import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SimpleTypeahead from "vue3-simple-typeahead";
import "vue3-simple-typeahead/dist/vue3-simple-typeahead.css"; //Optional default CSS


import _ from "lodash";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  emits: ["onSelect", "updateInput"],
  setup(__props, { emit: __emit }) {

const items = ref([]);

let url: string;

const emit = __emit;

function onFetch(e: any) {
  const keyword = e.input;
  url = `/api/autocomplete/${keyword}`;

  if (process.env.NODE_ENV !== "production") {
    url = `${process.env.VUE_APP_LOCAL_URL}/api/autocomplete/${keyword}`;
  }

  if (keyword && !_.isEmpty(keyword)) {
    fetch(url)
      .then((d) => d.json())
      .then((d) => {
        // console.log(d.data)
        items.value = d.data;
      })
      .catch((e) => {
        items.value = [];
        console.error(e);
      });
  } else {
    items.value = [];
  }
}
//
// defineExpose({ fetch })
//
// fetch(keyword)

function itemProjectionFunction(e: any) {
  return `${e.key}: ${e.gene_names}(${e.protein_names})`;
}

function selectedItemProjectionFunction(e: any) {
  return e.key;
}

function selectItemEventHandler(e: any) {
  emit("onSelect", e.key);
}

function onBlurEventHandler(e: any) {
  emit("updateInput", e.input);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SimpleTypeahead), {
    class: "form-control",
    id: "typeahead_id",
    placeholder: "Enter search term. (e.g. immunoglobulin)",
    items: items.value,
    minInputLength: 1,
    itemProjection: itemProjectionFunction,
    selectedItemProjection: selectedItemProjectionFunction,
    onSelectItem: selectItemEventHandler,
    onOnFetch: onFetch,
    onOnBlur: onBlurEventHandler
  }, null, 8, ["items"]))
}
}

})